import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@/router/root-route';
import ProgramBenefitsPage from '@/features/programs/program-create-benefits/ProgramBenefitsPage';

export const programCreateBenefitsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/programas/novo/beneficios',
  component: ProgramBenefitsPage,
});
